import { defineComponent, inject } from 'vue';
import Cell from '../Cell';
import { useInjectTable } from '../context/TableContext';
import { getCellFixedInfo } from '../utils/fixUtil';
import { getColumnsKey } from '../utils/valueUtil';
import DragHandleVue from './DragHandle';
import { HasDataKey } from '../context/ResizeContext';
export default defineComponent({
    name: 'HeaderRow',
    props: [
        'cells',
        'stickyOffsets',
        'flattenColumns',
        'rowComponent',
        'cellComponent',
        'index',
        'customHeaderRow',
    ],
    setup(props) {
        const tableContext = useInjectTable();
        const hasData = inject(HasDataKey);
        return () => {
            const { prefixCls, direction } = tableContext;
            const { cells, stickyOffsets, flattenColumns, rowComponent: RowComponent, cellComponent: CellComponent, customHeaderRow, index, } = props;
            let rowProps;
            if (customHeaderRow) {
                rowProps = customHeaderRow(cells.map(cell => cell.column), index);
            }
            const columnsKey = getColumnsKey(cells.map(cell => cell.column));
            return (<RowComponent {...rowProps}>
          {cells.map((cell, cellIndex) => {
                    const { column } = cell;
                    const fixedInfo = getCellFixedInfo(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
                    let additionalProps;
                    if (column && column.customHeaderCell) {
                        additionalProps = cell.column.customHeaderCell(column);
                    }
                    const col = column;
                    const minAndMaxWidth = {
                        isMinWidth: col.minWidth === col.width,
                        isMaxWidth: col.maxWidth === col.width,
                    };
                    const handleResizeColumn = w => {
                        minAndMaxWidth.isMaxWidth = w === col.maxWidth;
                        minAndMaxWidth.isMinWidth = w === col.minWidth;
                    };
                    return (<Cell {...cell} cellType="header" ellipsis={column.ellipsis} align={column.align} component={CellComponent} prefixCls={prefixCls} key={columnsKey[cellIndex]} {...fixedInfo} additionalProps={additionalProps} rowType="header" column={column} {...minAndMaxWidth} v-slots={{
                            default: () => column.title,
                            dragHandle: () => col.resizable && hasData.value ? (<DragHandleVue prefixCls={prefixCls} width={col.width} minWidth={col.minWidth} maxWidth={col.maxWidth} column={col} resizeColumn={handleResizeColumn}/>) : null,
                        }}/>);
                })}
        </RowComponent>);
        };
    },
});
